import type { ConfigContract } from "../types";

export default {
  TAMEENI_HOME: "https://qcmotor.gettameeni.com",
  API_BASE_URL: "https://travel-qc.gettameeni.com/backend/api/v1/",
  CONNECTION_API_URL:
    "https://travel-qc.gettameeni.com/backend/QuoteNotifierHub",
  AMEEN_URL: "https://qcmotor.gettameeni.com/ameen",
  IDENTITY_URL: "https://idpuat.gettameeni.com/",
  IDENTITY_CLIENT_ID: "travel-qc",
  IDENTITY_CLIENT_SECRET: "rasan@123",
  IDENTITY_REDIRECT_URL: "https://travel-qc.gettameeni.com",
  APP_URL: "https://travel-qc.gettameeni.com",
  OTP_TIMER: 3,
  SESSION_MAX_AGE: 120 * 60,
  IS_LOGIN_ENFORCE: true,
  AUTH_TRUST_HOST: "true",
  NEXT_PUBLIC_APP_ENV: "testing",
  AUTH_SECRET: "secret",
  NEXTAUTH_URL: "https://travel-qc.gettameeni.com",
  NEXT_PUBLIC_GTM_ENABLED: "true",
  NEXT_PUBLIC_GTM_ID: "GTM-K7FZCSM",
  FILTER_MIN_QUOTATIONS: 4,
} satisfies ConfigContract;
